// The statuses the tab lists, expanded to their sub-statuses by statusOptionsWithChildren.
export const LISTED_TOP_LEVEL_STATUSES = ['registered', 'matriculated', 'graduated'] as const;

export const DEFAULT_PAGE_SIZE = 20;

// Long enough to swallow the gap between two keystrokes.
export const QUICK_FILTER_DELAY_MS = 250;

export const VERIFIED_BY_ADMIN = 'verified_by_admin';

export const CSV_FILE_PREFIX = 'User';
export const CSV_TIMESTAMP_FORMAT = 'YYYY.MM.DD.HH.mm';

export const MAX_UPLOAD_SIZE_BYTES = 30 * 1024 * 1024;
export const UPLOAD_ACCEPT =
    'application/pdf,application/msword,' +
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document,' +
    'image/jpg,image/webp,image/png,image/jpeg';
export const SUPPORTED_UPLOAD_FORMATS = '.pdf, .doc, .docx, .jpg, .png';

export const LOAD_ERROR_MESSAGE = 'Failed to load students. Please try again.';
export const SAVE_ERROR_MESSAGE = 'Failed to save. Please try again.';
export const UPLOAD_ERROR_MESSAGE = 'Something went wrong';
